import React from 'react';
import profileImage from '../assets/images/companyprofile.png';

const CompanyProfile = () => {
    const expertise = [
        "Cloud Computing",
        "ERP",
        "CRM",
        "B2B Applications",
        "B2C applications",
        "E-commerce solutions",
        "IT Infrastructure Management",
        "Enterprise Application",
        "Automation of Application",
        "Blockchain Technology"
    ];

    return (
        <section id="profile" className="relative overflow-hidden min-h-[600px] flex items-stretch">
            {/* Background Split */}
            <div className="absolute inset-y-0 left-0 w-full lg:w-[61%] bg-white z-0" />
            <div className="absolute inset-y-0 right-0 hidden lg:block lg:w-[39%] bg-[#1a2332] z-0" />

            <div className="container mx-auto relative z-10 flex flex-col lg:flex-row">
                {/* Left Content */}
                <div className="lg:w-[61%] pt-12 pb-16 md:pb-20 px-6 md:px-12 flex flex-col">
                    <h2 className="text-[#f39c12] text-3xl md:text-4xl font-bold mb-8 md:mb-10 uppercase tracking-tight">
                        Company Profile
                    </h2>

                    <div className="text-[#334155] leading-[1.8] space-y-6 md:space-y-8 text-base md:text-lg max-w-3xl">
                        <p>
                            Developing innovative products to help businesses to find solutions is what we do best at.
                            Enablement of next-generation services is our forte, they include a vast majority of communication and information solutions that aid in business fulfillment.
                            We believe in creating world-class tailor-made solutions that are business-specific.
                        </p>
                        <p className="pl-6 md:pl-1.5">
                            Our philosophy remains on extensive business analysis, developing software solutions with impeccable quality and timely delivery.
                        </p>
                    </div>

                    <div className="mt-10 md:mt-14 relative group">
                        <h3 className="text-lg md:text-xl text-[#334155] mb-6 md:mb-8 font-medium">Our Expertise lies in</h3>
                        <div className="flex items-start">
                            <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-12 text-[#334155] text-sm md:text-base font-medium">
                                {expertise.map((item, index) => (
                                    <li key={index} className="flex items-center gap-3">
                                        <span className="w-1.5 h-1.5 bg-[#334155] rounded-full shrink-0" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Right Content - Illustration Overlay */}
                <div className="lg:w-[39%] bg-[#1a2332] lg:bg-transparent flex items-center justify-center py-16 lg:py-0 px-6 mb-20">
                    <img
                        src={profileImage}
                        alt="Company Profile Illustration"
                        className="w-full max-w-[280px] md:max-w-sm h-auto object-contain drop-shadow-2xl mx-auto"
                    />
                </div>
            </div>
        </section>
    );
};

export default CompanyProfile;

